import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuditTrailData, AuditQueryParams, AuditQueryResult } from './audit-trail.model';
import { GetFileInputData, ResourceService } from 'common';
import { AppSettings } from '../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class AuditTrailService {
  private readonly baseUrl: string;

  constructor(
    private http: HttpClient,
    private resourceService: ResourceService,
    private settings: AppSettings) {
    this.baseUrl = `${this.settings.audit.url}/audit`;
  }

  getById(id: number): Observable<AuditTrailData> {
    return this.http.get<AuditTrailData>(`${this.baseUrl}/${id}`);
  }

  audit(params: AuditQueryParams): Observable<AuditQueryResult> {
    return this.http.get<AuditQueryResult>(`${this.baseUrl}`, {
      params: <any>params
    });
  }

  auditDownload(params: AuditQueryParams): void {
    const inputData: GetFileInputData = {
      url: `${this.baseUrl}/csv`,
      filename: "audit.csv",
      params
    };
    this.resourceService.download(inputData).subscribe();
  }

  hints(params: AuditQueryParams): Observable<any> {
    return this.http.get(`${this.settings.audit.url}/workflowevents`, { params: <any>params});
  }
}
